module.exports = __webpack_public_path__ + "img/nominatorBg.13f339fd.png";